"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandRingAtAntimeridian = exports.cutRingAtAntimeridian = exports._crossingAntimeridianPointLat = exports._isCrossingAntimeridian = exports._warpWithin = void 0;
var _validates_1 = require("./_validates");
var calc_1 = require("./calc");
var errors_1 = require("./errors");
var utils_1 = require("./utils");
function _warpWithin(lon) {
    while (lon < -180)
        lon = lon + 360;
    while (180 < lon)
        lon = lon - 360;
    return lon;
}
exports._warpWithin = _warpWithin;
function _isCrossingAntimeridian(lon1, lon2) {
    /*
      The distance in the longitude between the points must be less than 180deg.
  
      lon1 = -10, lon2 = 10 -> False
      lon1 = 170, lon2 = 190 -> True
      lon1 = 170, lon2 = -170 -> True
    */
    if (Math.abs(lon1 - lon2) > 360)
        return true;
    lon1 = _warpWithin(lon1);
    lon2 = _warpWithin(lon2);
    if (Math.abs(lon1) === 180 || Math.abs(lon2) === 180)
        return false;
    if (lon1 * lon2 > 0)
        return false;
    return Math.abs(lon1 - lon2) > 180;
}
exports._isCrossingAntimeridian = _isCrossingAntimeridian;
function _crossingAntimeridianPointLat(p1, p2) {
    /*
      p1=[-150, 0], p2=[170, 20]) -> 15
      p1=[-20,-10], p2=[10, 170] -> 85
      p1=[-20, 66], p2=[10, 0]) -> 34
      p1=[-160, 32], p2=[170, 20]) -> 24
    */
    var x1 = p1[0];
    var x2 = p2[0];
    var y1 = p1[1];
    var y2 = p2[1];
    while (x1 < 0)
        x1 += 360;
    while (x2 < 0)
        x2 += 360;
    var bound = 180 * Math.floor(Math.max(x1, x2) / 180);
    return (0, calc_1.linearInterpolationY)([x1, y1], [x2, y2], bound);
}
exports._crossingAntimeridianPointLat = _crossingAntimeridianPointLat;
function _cutting(linearRing, start, end) {
    var ringIndex = start["to"] !== linearRing.length - 1 ? start["to"] : 0;
    var diff = linearRing[start["to"]][0] - linearRing[start["from"]][0];
    var r2l = Math.abs(diff) < 180 ? diff < 0 : diff > 0;
    var boundLon = r2l ? 180 * Math.ceil(linearRing[ringIndex][0] / 180) : 180 * Math.floor(linearRing[ringIndex][0] / 180);
    var rtn = { overflowing: !r2l, linearRing: [] };
    rtn.linearRing.push([
        boundLon,
        _crossingAntimeridianPointLat(linearRing[start["from"]], linearRing[start["to"]]),
    ]);
    rtn.linearRing.push(linearRing[start["to"]]);
    while (ringIndex !== end["from"]) {
        ringIndex = ringIndex + 1 !== linearRing.length - 1 ? ringIndex + 1 : 0;
        rtn.linearRing.push(linearRing[ringIndex]);
    }
    rtn.linearRing.push([
        boundLon,
        _crossingAntimeridianPointLat(linearRing[end["from"]], linearRing[end["to"]]),
    ]);
    rtn.linearRing.push(rtn.linearRing[0]);
    return rtn;
}
function cutRingAtAntimeridian(linearRing, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    /*
      When overflowing is True, points are right side of 180 degrees.
      The overflowing flag is used when recursive.
      The distance in the longitude between the points must be less than 180deg.
    */
    (0, _validates_1.validLinearRing)(linearRing);
    var options = Object.assign({
        overflowing: false,
        allowSelfintersection: false,
    }, userOptions);
    var crossingLats = [];
    for (var i = 0; i < linearRing.length - 1; i++) {
        if (_isCrossingAntimeridian(linearRing[i][0], linearRing[i + 1][0])) {
            crossingLats.push({
                from: i,
                to: i + 1,
                lat: _crossingAntimeridianPointLat(linearRing[i], linearRing[i + 1]),
            });
        }
    }
    if (crossingLats.length < 2)
        return !options.overflowing
            ? {
                within: [linearRing],
                outside: [],
            }
            : {
                within: [],
                outside: [linearRing],
            };
    crossingLats.sort(function (a, b) {
        return b.lat - a.lat;
    });
    var start = crossingLats[0];
    var end = crossingLats[1];
    var ret = {
        within: [],
        outside: [],
    };
    var cut1 = _cutting(linearRing, start, end);
    var result1 = cutRingAtAntimeridian(cut1.linearRing, {
        overflowing: cut1.overflowing,
        allowSelfintersection: options.allowSelfintersection,
    });
    ret.within = ret.within.concat(result1.within);
    ret.outside = ret.outside.concat(result1.outside);
    var cut2 = _cutting(linearRing, end, start);
    var result2 = cutRingAtAntimeridian(cut2.linearRing, {
        overflowing: cut2.overflowing,
        allowSelfintersection: options.allowSelfintersection,
    });
    ret.within = ret.within.concat(result2.within);
    ret.outside = ret.outside.concat(result2.outside);
    if (!options.allowSelfintersection) {
        ret.within.forEach(function (ring) {
            if ((0, utils_1.selfintersection)(ring))
                throw new errors_1.InvalidSelfintersectionError();
        });
        ret.outside.forEach(function (ring) {
            if ((0, utils_1.selfintersection)(ring))
                throw new errors_1.InvalidSelfintersectionError();
        });
    }
    return ret;
}
exports.cutRingAtAntimeridian = cutRingAtAntimeridian;
function expandRingAtAntimeridian(linearRing) {
    (0, _validates_1.validLinearRing)(linearRing);
    var crossingPoints = [];
    for (var i = 0; i < linearRing.length - 1; i++) {
        if (_isCrossingAntimeridian(linearRing[i][0], linearRing[i + 1][0])) {
            crossingPoints.push({
                from: i,
                to: i + 1,
            });
        }
    }
    if (crossingPoints.length < 2)
        return linearRing;
    var ring = __spreadArray([], linearRing, true);
    var before = 0;
    for (var i = 0; i < crossingPoints.length; i++) {
        var startTo = crossingPoints[i].to;
        var startFrom = crossingPoints[i].from;
        var warp = ring[startTo][0] * ring[startFrom][0] < 0;
        var endFrom = i < crossingPoints.length - 1 ? crossingPoints[i + 1].from : ring.length;
        if (warp) {
            if (ring[startTo][0] < 0) {
                for (var j = startTo; j < endFrom; j++) {
                    ring[j][0] += 360;
                }
            }
            else {
                for (var j = before; j <= startFrom; j++) {
                    ring[j][0] += 360;
                }
            }
        }
        before = endFrom;
    }
    return ring;
}
exports.expandRingAtAntimeridian = expandRingAtAntimeridian;
